export default __webpack_public_path__ + "static/Cecilie-jonassen-and-team-604b2da44923d45940fb740ad07aefae.jpg";